import React from 'react'
import HeadingText from '../ActionCommonComponent/HeadingText'

const UserInfo = ({data={},changeLable}) => {
  if(changeLable){
    return (
      <div style={{marginBottom:"10px"}}> 
        <HeadingText 
            heading={`${data.purpose === "Submit" ? "Submission Required by" :
                        data.purpose === "Release" ? "Release Required from" : 
                        data.purpose === "Approve" ? "Approval Required from" : ""
            }:`} text={data.name ? data.name : (data.user?.first_name+" "+data.user?.last_name)} normal={true}/>
      </div>
    )
  }else{
    return (
      <div style={{marginBottom:"10px"}}> 
        <HeadingText 
            heading={`${data.purpose === "Submit" ? "Submitter" :
                        data.purpose === "Release" ? "Releaser" : 
                        data.purpose === "Approve" ? "Approver" : "Rejector"
            }:`} text={data.name ? data.name : (data.user?.first_name+" "+data.user?.last_name)} normal={true}/>
      </div>
    )
    
  }
}

export default UserInfo